module.exports = __webpack_public_path__ + "img/production.95469a4c.png";